export class LocationCoordinates {

    constructor(lat: number, lon: number) {
        this.latitude = lat;
        this.longitude = lon;
    }

    public latitude: number;
    public longitude: number;
}